"use client";

import { BSRCreditCard } from "./bsr/BSRCreditCard";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { CreditCard as LegacyCreditCard } from "./legacy/CreditCard";

export const CreditCard = createBSRExperimentIcon(
  LegacyCreditCard,
  BSRCreditCard
);
